import {Fragment} from 'react';

import {ValueReplacesService as Service} from './ValueReplacesService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const typeIn = 1;
  const header = t('menu.valueReplacement');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'fieldName', header: t('system.fieldName'), minWidth: 250, matchMode: 'contains'},
      {field: 'value', header: t('system.value'), width: 200, matchMode: 'contains'},
      {field: 'replace', header: t('menu.valueReplacement'), width: 200, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.type = typeIn;
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'fieldName', header: t('system.fieldName'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'value', header: t('system.value'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'replace', header: t('menu.valueReplacement'), InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      item.type = typeIn;
      return Service.create(item);
    },
    updateItem: (id, item) => {
      item.type = typeIn;
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
